"use client";

import { createContext } from "react";

import type { CompanyMetaContextValue } from "./get-company-meta.types";

export const CompanyMetaContext = createContext<CompanyMetaContextValue>({} as CompanyMetaContextValue);
